<template>
  <CModal :show.sync="show" centered>
    <template #header>
      <div>
        <div class="d-flex">
          <CIcon name="cipSignal" size="custom-size" width="36" height="36"
                 class="mr-3 icon-circle icon-circle--primary"/>
          <div class="align-self-center">
            <h5 class="modal-title" v-translate translate-context="event.modal.create_new_event.title">Activate
              event</h5>
          </div>
        </div>
      </div>
      <CButtonClose @click="show = false"/>
    </template>

    <template v-if="!allMandatoryIsPresent">
      <Suggestions :suggestions="suggestions"/>
    </template>
    <template v-else-if="!isPaid">
      <PlanOptionsSelector
          :options="planOptionsSorted"
          :selected="planOptionId"
          @input="onSelectPlanOption"
      />
    </template>
    <template v-else>
      All ok, ready to publish!
      <Suggestions :suggestions="suggestions"/>
    </template>

    <template #footer>
      <CButton color="secondary" size="sm" @click="show = false" v-translate>Close</CButton>
      <template v-if="!allMandatoryIsPresent">

      </template>
      <template v-else-if="!isPaid">
        <PButton
            color="primary" v-translate translate-context="event.modal.publish.actions" class="mr-3"
            :disabled="!planOptionId"
            @click="onPayment">
          Activate for {{ 0|currency('EUR') }}
        </PButton>
      </template>
      <template v-else>
        <PButton
            v-if="allMandatoryIsPresent"
            color="primary" v-translate translate-context="event.modal.publish.actions" class="mr-3"
            @click="onPublish">
          Publish
        </PButton>
      </template>
    </template>
  </CModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PButton from "@/components/PButton.vue";
import Suggestions from "@/domain/events/components/Suggestions.vue";
import PlanOptionsSelector from "@/domain/events/components/PlanOptionsSelector.vue";

export default {
  name: "PublishEventModal",
  emits: ['published'],
  components: {
    PlanOptionsSelector,
    Suggestions,
    PButton,
  },
  data() {
    return {
      show: false,
      loading: true,
      planOptionId: null,
    }
  },
  computed: {
    ...mapGetters('eventWizard', [
      'allMandatoryIsPresent',
      'suggestions',
      'planOptions',
      'isPaid'
    ]),
    planOptionsSorted() {
      if (!this.planOptions) return []
      return [...this.planOptions].sort((a, b) => a.price - b.price)
    }
  },
  methods: {
    ...mapActions('eventWizard', [
      'publish',
      'fetchPlanOptions',
      'fetchPublishValidation',
      'fetchFormData',
      'fetchEventConfiguration'
    ]),
    async open() {
      this.show = true
      this.loading = true
      await this.fetchPublishValidation()
      if (this.allMandatoryIsPresent && !this.isPaid) {
        await this.fetchPlanOptions()
        if (this.planOptionsSorted.length) {
          this.planOptionId = this.planOptions.find(option => option.current).id
        }
      }

      this.loading = false
    },
    onSelectPlanOption(option) {
      this.planOptionId = option.id
    },
    async handlePublish() {
      await this.publish()
      await this.fetchEventConfiguration()
      await this.fetchFormData()

    },
    async onPublish() {
      await this.handlePublish()
      this.$emit('published')
      this.show = false
    },
    async onPayment() {
      await this.handlePublish()
      this.$emit('published')
      this.show = false
    },
  }
}
</script>